// extracted by mini-css-extract-plugin
export var base = "_1v-0";
export var updateBanner = "_1v-1";